import styled, { css } from 'styled-components';
import {
    basicColor,
    device,
    fadeIn,
    radius,
    size,
    slideIn
} from '@/styles/template';
import {ArticleH2} from "@/pages/designSystem/Fonts";

export const ModalWrap = styled.div`
    color: ${props => props.theme.color.Text} !important;
    position: fixed;
    overflow: hidden;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    z-index: 1000;
`;

interface ContainerProps {
    colorful?: boolean;
    mode?: 'successPrompt' | 'errorPrompt';
}

export const Container = styled.div<ContainerProps>`
    position: absolute;
    overflow: hidden auto;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    background: ${({ theme }) => theme.color.Background};
    

    ${({ mode }) => (mode === 'successPrompt' || mode === 'errorPrompt') && css`
        color: ${basicColor.white};
        width: fit-content;
        height: fit-content;
        padding: 6rem!important;
        border-radius: ${radius.large};
    `}

    ${({ mode }) => (mode === 'successPrompt') && css`
        background: ${basicColor.secondaryDark};
    `}
    
    ${({ mode }) => (mode === 'errorPrompt') && css`
        background: ${basicColor.red};
    `}
    
    max-width: ${size.tablet};
    margin: auto;
    padding: 6rem 2rem 3rem;

  @media ${device.tablet} {
      border-radius: ${radius.large};
      max-height: 90vh;
      height: fit-content;
      padding: 6rem;
      //width: fit-content;
  }
    
    animation: ${slideIn} .6s cubic-bezier(0.280, 0.840, 0.420, 1);
    box-shadow: ${({ theme }) => theme.boxShadow.Extreme};
`

export const Overlay = styled.div`
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background-color: ${({ theme }) => theme.color.Overlay};
    animation: ${fadeIn} .7s cubic-bezier(0.280, 0.840, 0.420, 1);
`;

export const ModalTitle = styled(ArticleH2)`
    color: ${({ theme }) => theme.color.Text};
`

export const ExitButtonWrapper = styled.div`
    position: absolute;
    top: 0;
    right: 0;
`;

export const PopupInnerVerticalStretch = styled.div`
  	min-height: calc(100vh - 9rem);
    display: flex;
    gap: 3rem;
    flex-direction: column;
    flex-wrap: nowrap;
    justify-content: space-between;
	@media ${device.tablet} {
		min-height: auto;
	}
`